// @flow

import React, { type Node, useEffect } from 'react';
import { Empty } from '@tectonics/look-and-feel/commons/components';
import { useIncomingPayment, getReceipts, getCountry } from '@tectonics/prs/incoming-payment';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { getAmountExt, useCurrentReceipt } from '@tectonics/prs/receipts';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { amountToCurrencyString } from '@tectonics/prs/money';

import { getMoneyFormat } from '../../../utils/money-format';

export function TotalAmountOverride(): Node {
  const incomingPayment = useIncomingPayment();
  const [selectedPaymentMethod] = useUserInputValue('selectedPaymentMethod');
  const currentReceipt = useCurrentReceipt();

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll('[data-checkout-payment-due-target]'));

    const amount = selectedPaymentMethod
      ? getReceiptAmountLocalTotal(currentReceipt)
      : getAmountExt(getReceipts(incomingPayment));

    const decimalFormat = getMoneyFormat(getCountry(incomingPayment));

    const formatAmount = amountToCurrencyString(decimalFormat);

    const formattedAmount = formatAmount(amount);

    elements.forEach(element => {
      const { previousElementSibling } = element;
      if (
        previousElementSibling instanceof HTMLElement &&
        previousElementSibling.classList.contains('payment-due__currency')
      ) {
        previousElementSibling.innerText = amount[0];
      }

      element.innerHTML = formattedAmount;
    });
  }, [incomingPayment, selectedPaymentMethod, currentReceipt]);

  return <Empty />;
}
